import config from 'config'
import storage from 'util/storage'

export const isLiveChatEnabled =
  config.isDevelopment ||
  config.isAlpha ||
  config.isStaging ||
  storage.get('isLiveChatEnabled')
